import React, { useState, useCallback } from 'react';
import Sidebar from './Sidebar';
import TopNav from './TopNav';
import PreviewModeBanner from '../PreviewModeBanner';
import { PullToRefreshIndicator } from '../PullToRefreshIndicator';
import { usePullToRefresh } from '../../hooks/usePullToRefresh';

const DashboardLayout = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleRefresh = useCallback(async () => {
    // Trigger a page-level refresh of data
    window.dispatchEvent(new CustomEvent('hibff:pull-refresh'));
    // Brief delay so the spinner is visible
    await new Promise(r => setTimeout(r, 600));
  }, []);

  const { pullProps, isPulling, isRefreshing, pullDistance, threshold } = usePullToRefresh(handleRefresh);

  return (
    <div className="dashboard-layout min-h-screen">
      {/* Admin Preview Banner — shows on all pages during demo */}
      <PreviewModeBanner />

      {/* Sidebar */}
      <Sidebar isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />

      {/* Main Content Area */}
      <div className="main-content-wrapper" {...pullProps}>
        {/* Top Navigation */}
        <TopNav onMenuClick={() => setIsMobileMenuOpen(true)} />

        {/* Pull-to-Refresh Indicator */}
        <PullToRefreshIndicator
          pullDistance={pullDistance}
          threshold={threshold}
          isRefreshing={isRefreshing}
        />

        {/* Content */}
        <main className="main-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
